// formConfigVaga.js
export const formStructure = [
  [
    {
      name: 'Titulo',
      label: 'Título da Vaga',
      placeholder: 'Ex: Motorista',
      component: 'FormField',
      type: 'text',
      colProps: { md: 8 },
      required: true,
      maxLength: 200,
      validation: { required: 'Título é obrigatório' },
    },
    {
      name: 'NecessitaCNH',
      label: 'Necessita CNH?',
      placeholder: 'Selecione...',
      component: 'SearchSelect',
      isMulti: false,
      colProps: { md: 4 },
      required: true,
      options: [
        { label: 'Não', value: '0' },
        { label: 'Sim', value: '1' },
      ],
      validation: { required: 'Informe se a vaga necessita CNH' },
    },
  ],
  [
    {
      name: 'EncerramentoAutomatico',
      label: 'Encerramento automático?',
      placeholder: 'Selecione...',
      component: 'SearchSelect',
      isMulti: false,
      colProps: { md: 6 },
      options: [
        { label: 'Não', value: '0' },
        { label: 'Sim', value: '1' },
      ],
    },
    {
      name: 'DataEncerramentoAutomatico',
      label: 'Data de encerramento automático',
      placeholder: 'Selecione data e hora',
      component: 'FormField',
      type: 'datetime-local',
      colProps: { md: 6 },
    },
  ],
  [
    {
      name: 'Endereco',
      label: 'Endereço / Local',
      placeholder: 'Ex.: Av. Paulista, 1000 - São Paulo/SP',
      component: 'FormField',
      type: 'text',
      colProps: { md: 12 },
      maxLength: 255,
    },
  ],
  [
    {
      name: 'Descricao',
      label: 'Descrição (curta)',
      placeholder: 'Resumo da vaga',
      component: 'FormField',
      type: 'text',
      colProps: { md: 12 },
      maxLength: 500,
    },
  ],
  [
    {
      name: 'Salario',
      label: 'Salário',
      placeholder: 'Ex.: 5000.00',
      component: 'FormField',
      type: 'number',
      step: '0.01',
      colProps: { md: 12 },
    },
    {
      name: 'complementaresIds',
      label: 'Informações Complementares',
      placeholder: 'Selecione as opções...',
      component: 'FormField',
      type: 'multiselect',
      colProps: { md: 6 },
      optionsSource: 'complementares',
    },
    {
      name: 'beneficiosIds',
      label: 'Benefícios',
      placeholder: 'Selecione os benefícios...',
      component: 'FormField',
      type: 'multiselect',
      colProps: { md: 6 },
    },
  ],
];

export const formSections = (initialValues) => [
  {
    title: `Detalhes da Vaga ${initialValues?.Titulo ? `— ${initialValues.Titulo}` : ''}`,
    rows: [0, 1, 2, 3, 4],
  },
];


export const validateForm = (values) => {
  const errors = {};
  if (!values.Titulo || !values.Titulo.trim()) {
    errors.Titulo = 'Título é obrigatório';
  }

  if (values.NecessitaCNH === undefined || values.NecessitaCNH === '') {
    errors.NecessitaCNH = 'Informe se a vaga necessita CNH';
  }

  const encerramentoValue = typeof values.EncerramentoAutomatico === 'object' && values.EncerramentoAutomatico
    ? values.EncerramentoAutomatico.value
    : values.EncerramentoAutomatico;
  if (String(encerramentoValue) === '1' && !values.DataEncerramentoAutomatico) {
    errors.DataEncerramentoAutomatico = 'Informe a data de encerramento automÇ­tico';
  }
  return errors;
};
